export default __webpack_public_path__ + "static/media/agent-profile-default.5dd77834.jpg";